import React from 'react';
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';
import { Card, CardContent, Typography } from '@material-ui/core';
import styled from 'styled-components';

const ChartCard = styled(Card)`
  height: 320px;
`;

const ChartContent = styled(CardContent)`
  height: 100%;
`;

const WeightRunChart = ({ title, data, targetWeight, lowerLimit, upperLimit }) => {
  return (
    <ChartCard elevation={2}>
      <ChartContent>
        <Typography variant="subtitle1" gutterBottom>
          {title}
        </Typography>

        <ResponsiveContainer width="100%" height={260}>
          <ScatterChart>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="timestamp" tick={{ fontSize: 11 }} minTickGap={20} />
            <YAxis dataKey="weight" tick={{ fontSize: 11 }} />
            <Tooltip />

            {targetWeight != null && (
              <ReferenceLine y={targetWeight} stroke="#1976d2" strokeDasharray="3 3" />
            )}

            {lowerLimit != null && (
              <ReferenceLine y={lowerLimit} stroke="#d32f2f" strokeDasharray="3 3" />
            )}

            {upperLimit != null && (
              <ReferenceLine y={upperLimit} stroke="#d32f2f" strokeDasharray="3 3" />
            )}

            <Scatter
              name="Peso"
              data={data}
              fill="#8884d8"
              isAnimationActive={false}
            />
          </ScatterChart>
        </ResponsiveContainer>
      </ChartContent>
    </ChartCard>
  );
};

export default WeightRunChart;
